import React, { useState } from 'react';

const s = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9999,
    background: 'rgba(0,0,0,0.7)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '16px',
  },
  modal: {
    background: '#fff', borderRadius: '16px',
    maxWidth: '520px', width: '100%',
    padding: '40px 32px 32px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
    maxHeight: '90vh', overflowY: 'auto',
  },
  icon: { fontSize: '40px', textAlign: 'center', marginBottom: '16px' },
  title: { fontSize: '22px', fontWeight: '700', color: '#1a1a2e', margin: '0 0 8px', textAlign: 'center' },
  sub: { fontSize: '14px', color: '#6b7280', textAlign: 'center', margin: '0 0 24px', lineHeight: '1.6' },
  box: {
    background: '#f9fafb', border: '1px solid #e5e7eb',
    borderRadius: '10px', padding: '16px', marginBottom: '20px',
    fontSize: '13px', color: '#374151', lineHeight: '1.7',
  },
  boxTitle: { fontWeight: '700', color: '#1f2937', marginBottom: '8px', fontSize: '14px' },
  ul: { margin: '6px 0 0 0', paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '4px' },
  checkRow: {
    display: 'flex', alignItems: 'flex-start', gap: '12px',
    background: '#eff6ff', border: '1.5px solid #bfdbfe',
    borderRadius: '10px', padding: '14px 16px', marginBottom: '20px',
    cursor: 'pointer',
  },
  checkBox: { width: '20px', height: '20px', flexShrink: 0, marginTop: '2px', cursor: 'pointer', accentColor: '#2d2d7e' },
  checkLabel: { fontSize: '13px', color: '#1e40af', fontWeight: '500', lineHeight: '1.5', cursor: 'pointer' },
  btn: {
    width: '100%', padding: '14px', background: '#2d2d7e', color: '#fff',
    border: 'none', borderRadius: '10px', fontSize: '16px', fontWeight: '600',
    cursor: 'pointer',
  },
  btnDisabled: { opacity: 0.5, cursor: 'not-allowed' },
  logout: {
    width: '100%', marginTop: '10px', padding: '10px',
    background: 'none', border: 'none', color: '#9ca3af',
    fontSize: '13px', cursor: 'pointer', textDecoration: 'underline',
  },
  link: { color: '#2d2d7e', textDecoration: 'none', fontWeight: '600' },
};

export default function GdprConsentModal({ onAccept, onLogout }) {
  const [checked, setChecked] = useState(false);

  return (
    <div style={s.overlay}>
      <div style={s.modal}>
        <div style={s.icon}>🔒</div>
        <h2 style={s.title}>Informare privind prelucrarea datelor</h2>
        <p style={s.sub}>
          Înainte de a continua, vă rugăm să confirmați că ați luat la cunoștință
          modul în care sunt prelucrate datele dvs. cu caracter personal.
        </p>

        <div style={s.box}>
          <div style={s.boxTitle}>Ce date prelucrăm și de ce:</div>
          <ul style={s.ul}>
            <li>Date de identificare (nume, CNP, email) — pentru înregistrarea și soluționarea cererilor</li>
            <li>Date de contact (telefon, adresă) — pentru comunicarea cu privire la stadiul cererilor</li>
            <li>Istoricul cererilor și sesizărilor — pentru asigurarea continuității serviciilor</li>
            <li>Adresa IP și date de acces — pentru securitatea platformei (stocate 90 de zile)</li>
          </ul>

          <div style={{ ...s.boxTitle, marginTop: '12px' }}>Drepturile dvs. (GDPR Art. 15-22):</div>
          <ul style={s.ul}>
            <li>Dreptul de acces, rectificare și ștergere a datelor (Profil → Setări GDPR)</li>
            <li>Dreptul de a vă retrage consimțământul oricând, fără a afecta operațiunile anterioare</li>
            <li>Dreptul de a depune plângere la ANSPDCP (anspdcp.eu.int)</li>
          </ul>

          <p style={{ margin: '12px 0 0', fontSize: '12px', color: '#6b7280' }}>
            Operator de date: {window.__PRIMARIA_NUME__ || 'Primăria'} · Temei legal: Art. 6(1)(e) GDPR — interes public ·{' '}
            <a href="/confidentialitate" style={s.link} target="_blank" rel="noopener noreferrer">
              Politica completă de confidențialitate →
            </a>
          </p>
        </div>

        <label style={s.checkRow} onClick={() => setChecked(c => !c)}>
          <input
            type="checkbox"
            style={s.checkBox}
            checked={checked}
            onChange={e => setChecked(e.target.checked)}
            onClick={e => e.stopPropagation()}
          />
          <span style={s.checkLabel}>
            Am luat la cunoștință informările de mai sus privind prelucrarea datelor cu caracter personal
            și sunt de acord cu utilizarea platformei în condițiile descrise.
          </span>
        </label>

        <button
          style={{ ...s.btn, ...(checked ? {} : s.btnDisabled) }}
          disabled={!checked}
          onClick={onAccept}
        >
          Continuă în platformă
        </button>

        <button style={s.logout} onClick={onLogout}>
          Nu sunt de acord — Deconectează-mă
        </button>
      </div>
    </div>
  );
}
